<template>
    <div>
        <kgr-loading v-if="loading" />
        <div v-else>
            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                {{ $t('kindergarten.hintOptions.headline') }}
            </h3>
            <kgr-accordion>
                <kgr-accordion-item
                    v-for="(visibilityCategory, category) in visibilities"
                    :key="category"
                    :title="$t(`problem.category.${category}`)"
                >
                    <div
                        v-for="(visibility, index) in visibilityCategory"
                        :key="visibility.problem"
                        class="kgr-row"
                    >
                        <kgr-checkbox
                            :checked="visibility.visible"
                            :label="$t(`hint.visibility.${visibility.problem}`)"
                            @change="updateVisibility(category, index, { problem: visibility.problem, category: visibility.category, visible: $event })"
                        />
                    </div>
                </kgr-accordion-item>
            </kgr-accordion>
            <div class="app-formFooter">
                <div class="app-formFooter__hint"></div>
                <div class="app-formFooter__actions">
                    <div></div>
                    <div>
                        <kgr-button
                            :value="$t('save')"
                            :pending="pending"
                            class="right"
                            @click="update()"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Accordion from '../../components/common/accordion/Accordion';
import AccordionItem from '../../components/common/accordion/AccordionItem';
import Checkbox from '../../components/common/form/checkbox/Checkbox.vue';
import KgrButton from '../../components/common/form/button/KgrButton';
import Loading from '../../components/common/Loading';
import ProblemVisibilityRepository from '../../js/repository/ProblemVisibilityRepository';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-checkbox': Checkbox,
        'kgr-loading': Loading,
        'kgr-accordion': Accordion,
        'kgr-accordion-item': AccordionItem,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            visibilities: {},
            pending: false,
        };
    },
    created() {
        ProblemVisibilityRepository
            .findByKindergarten(this.kindergartenId)
            .then((data) => {
                this.visibilities = {};
                for (let i = 0; i < data.length; i++) {
                    const category = data[i].category;
                    if (!this.visibilities[category]) {
                        this.visibilities[category] = [];
                    }
                    this.visibilities[category].push({ problem: data[i].problem, visible: data[i].visible });
                }
                this.loading = false;
            })
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {
        update() {
            this.pending = true;
            const visibilities = [];
            for (const category in this.visibilities) {
                for (let i = 0; i < this.visibilities[category].length; i++) {
                    visibilities.push(this.visibilities[category][i]);
                }
            }
            ProblemVisibilityRepository
                .update(this.kindergartenId, visibilities)
                .then(() => {
                    this.$notify.success('saveChanges.success');
                    this.pending = false;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        updateVisibility(category, index, visibility) {
            this.$set(this.visibilities[category], index, visibility);
            this.$forceUpdate();
        },
    },
};
</script>
